import { Button } from "@mui/material";
import React from "react";

export default function ButtonExportProject(props) {

  const handleButtonClick = (e) => {
    props.canvasRef.current.ExportToPng();
  };

  return (
    <Button fullWidth sx={{ mt: "15px" }} onClick={handleButtonClick}>Export to PNG</Button>
  );
}